import { createAction, props } from '@ngrx/store';
import {
  ReportType,
  ScheduleReport,
} from '../reducers/scheduled-reports.reducer';

export const setScheduleFilter = createAction(
  '[ScheduledReports] Set Schedule Filter',
  props<{ scheduleFilter: { name: string; type: string } }>(),
);
export const resetScheduledReportsFilter = createAction(
  '[ScheduledReports] Reset Schedule Filter',
);
export const loadScheduledReports = createAction(
  '[ScheduledReports] Load ScheduledReports',
);

export const loadScheduledReportsSuccess = createAction(
  '[ScheduledReports] Load ScheduledReports Success',
  props<{ scheduleList: ScheduleReport[] }>(),
);

export const setSelectedReportType = createAction(
  '[ScheduledReports] Set Selected Report Type',
  props<{ reportType: ReportType }>(),
);

export const loadScheduledReportsFailure = createAction(
  '[ScheduledReports] Load ScheduledReports Failure',
  props<{ error: any }>(),
);

export const clearScheduleReportError = createAction(
  '[ScheduledReports] Clear Schedule Report Error',
);

export const addReportSchedule = createAction(
  '[ScheduledReports] Add Schedule Report',
  props<{ schedule: ScheduleReport }>(),
);
export const addReportScheduleSuccess = createAction(
  '[ScheduledReports] Add Schedule Report Success',
  props<{ schedule: ScheduleReport }>(),
);

export const deleteScheduleReport = createAction(
  '[ScheduleReports] Delete Schedule Report',
  props<{ id: number }>(),
);
export const deleteScheduleReportSuccess = createAction(
  '[ScheduleReports] Delete Schedule Report Success',
  props<{ id: number }>(),
);

export const updateSchedule = createAction(
  '[ScheduleReports] Update Schedule',
  props<{ schedule: ScheduleReport }>(),
);
export const updateScheduleSuccess = createAction(
  '[ScheduleReports] Update Schedule Success',
  props<{ schedule: ScheduleReport }>(),
);
